export enum LoadingState {
    IDLE = 'idle',
    PENDING = 'pending',
    ERROR = 'error',
    SUCCESS = 'success',
}
